import * as Immutable from "immutable";

const AttachmentMap = Immutable.OrderedMap;

export default AttachmentMap;
